<template>
  <div class="row mt-1">
    <div class="col d-flex justify-content-around">
      <button
        class="btn btn-primary btn-sm"
        v-for="a in auctions_"
        :key="a.id"
        @click="selectAuction(a.id)"
      >
        {{ a.name }}
      </button>
    </div>
  </div>
</template>
<script setup>
import { useStore } from "@/store/index";
import { onMounted, ref } from "vue";
import supabase from "@/supabase/config";
const store = useStore();
const auctions_ = ref([]);
onMounted(async () => {
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("auctioneer_id", store.user.id);
  auctions_.value = auctions;
});
const selectAuction = (id) => {
  store.setAuction(id);
  setBiddingOpenToFalse();
};
const setBiddingOpenToFalse = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ bidding_open: false })
    .eq("id", store.live_auction)
    .select();
};
</script>
